import VInputCardNumber from './index.vue';

export default {
  install: (Vue) => Vue.component('VInputCardNumber', VInputCardNumber),
};
